
/**
 * @fileOverview ThumbnailSliderView View Module File
 *
 * @author loytomaki
 * @version 1.0
 */


(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('views/ThumbnailSliderView',['require','jquery','GlobalEventDispatcher'],function (require) {

        var $ = require('jquery');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');
        /**
         * Description
         *
         * @class ThumbnailSliderView
         * @param {string} sliderId A reference to the id of the carousel.
         * @constructor
         */
        var ThumbnailSliderView = function (sliderId) {
            this.$slider = $(sliderId);
            this.$carousel = this.$slider.parent().prev();
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher(); // event dispatcher that will call the event, provided by the application
            this.$sliderList = undefined;
            this.$thumbnails = undefined;
            this.thumbnailCount = undefined;
            this.thumbnailWidth = undefined;
            this.shouldUseRTL = $('body').hasClass('rtl');
            this.animationProp = undefined;
            this.isLooping = false;
            this.isAnimating = false;
            this.init();
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         *
         * @method init
         * @returns {ThumbnailSliderView}
         * @private
         */
        ThumbnailSliderView.prototype.init = function () {
            this.isEnabled = false;

            return this.setupHandlers()
                .createChildren()
                .layout()
                .enable();
        };

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * @method setupHandlers
         * @returns {ThumbnailSliderView}
         * @private
         */
        ThumbnailSliderView.prototype.setupHandlers = function () {
            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.WINDOW_RESIZE, this.resetView.bind(this));

            return this;
        };

        /**
         * Create any child objects or references to DOM elements
         * Should only be run on initialization of the view
         *
         * @method createChildren
         * @returns {ThumbnailSliderView}
         * @private
         */
        ThumbnailSliderView.prototype.createChildren = function () {
            this.$sliderList = this.$slider.find('.js-sliderList');
            this.$thumbnails = this.$sliderList.children();
            this.thumbnailCount = this.$thumbnails.length;
            this.thumbnailWidth = this.$thumbnails.width();
            this.$triggerPrevious =  this.$slider.find('.js-sliderTrigger_left');
            this.$triggerNext =  this.$slider.find('.js-sliderTrigger_right');
            this.$triggerMainPrevious = this.$slider.parent().prev().find('.js-carouselTrigger_left');
            this.$triggerMainNext = this.$slider.parent().prev().find('.js-carouselTrigger_right');

            
            this.currentOffset = 0;
            this.maxOffset = 0;
            
            if (this.$carousel.data('isLooping') === true) {
                this.isLooping = true;
                //this.createLoopSlides();

            }

            return this;
        };

        /**
         * Performs measurements and applies any positioning style logic
         * Should be run anytime the parent layout changes
         *
         * @method layout
         * @returns {ThumbnailSliderView}
         * @public
         */
        ThumbnailSliderView.prototype.layout = function () {
            /**
             * check the width of the slider, compare it to the total width of the slides, if it is less then enable the buttons
             */
            var sliderWidth = this.$sliderList.outerWidth(true);
            var totalSlideWidth = this.thumbnailCount * this.thumbnailWidth;
            this.maxOffset = totalSlideWidth - sliderWidth;

            if (this.maxOffset < 0) {
                this.maxOffset = 0;
            }

            if(this.currentOffset === 0) {
                this.$triggerPrevious.addClass('triggerInactive');
            }

            if (sliderWidth >= totalSlideWidth) {
                this.disable();
            } else {
                this.enable();
            }

            //this.scrollToPosition(0, 0);
            console.log('this.currentOffset '+this.currentOffset);
            this.$sliderList.css({'marginLeft':-this.currentOffset+'px'});
            if (this.$fauxFirstSlide !== undefined) {
                this.$fauxFirstSlide.removeClass('fauxSlide');
            }

            if (this.$fauxLastSlide !== undefined) {
                this.$fauxLastSlide.removeClass('fauxSlide');
            }
            return this;
        };

        ThumbnailSliderView.prototype.resetView = function () {
            this.layout();
        };

        ThumbnailSliderView.prototype.createLoopSlides = function () {
            var fauxFirstSlideContent = this.$thumbnails.first().html();
            var fauxLastSlideContent = this.$thumbnails.last().html();

            this.$fauxFirstSlide = $('<li>' + fauxFirstSlideContent + '</li>');
            this.$fauxLastSlide = $('<li>' + fauxLastSlideContent + '</li>');
            // remove ID's from these two slides
            this.$fauxFirstSlide.removeAttr('id')
                .addClass('MMM--carouselList_thumb-item');

            this.$fauxLastSlide.removeAttr('id')
                .addClass('MMM--carouselList_thumb-item');

            this.$sliderList.prepend(this.$fauxLastSlide);
            this.$sliderList.append(this.$fauxFirstSlide);

            this.currentOffset = this.currentOffset + this.thumbnailWidth;
            
            return this;
        };


        /**
         * Enables the view
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @method enable
         * @returns {ThumbnailSliderView}
         * @public
         */
        ThumbnailSliderView.prototype.enable = function () {
            var self = this;
            if (this.isEnabled) {
                return this;
            }

            this.isEnabled = true;
            this.$triggerNext.on('click', self.scrollForward.bind(this));
            this.$triggerPrevious.on('click', self.scrollBackward.bind(this));

            this.$triggerMainNext.on('click', self.scrollForward.bind(this));
            this.$triggerMainPrevious.on('click', self.scrollBackward.bind(this));

            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.WINDOW_RESIZE, this.layout.bind(this));

            return this;

        };

        /**
         * Disables the view
         * Tears down any event binding to handlers
         * Exits early if it is already disabled
         *
         * @method disable
         * @returns {ThumbnailSliderView}
         * @public
         */
        ThumbnailSliderView.prototype.disable = function () {
            var self = this;
            if (!this.isEnabled) {
                return this;
            }

            this.isEnabled = false;

            this.$triggerNext.off('click', self.scrollForward);
            this.$triggerPrevious.off('click', self.scrollBackward);

            return this;
        };

        /**
         *
         * @method scrollForward
         * @param event {Event} JavaScript event object.
         * @private
         */
        ThumbnailSliderView.prototype.scrollForward = function (event) {
            //needed for IE Support
            if (event.preventDefault) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }
            
            this.$triggerPrevious.removeClass('triggerInactive');
            console.log('in scrollForward currentOffset '+this.currentOffset + ' maxOffset ' + this.maxOffset);
            if (!this.isLooping) {
                this.currentOffset = this.currentOffset + this.thumbnailWidth;
                if (this.currentOffset > this.maxOffset) {
                    this.currentOffset = this.maxOffset;
                    this.$triggerNext.addClass('triggerInactive');
                }
            }
            else {
                if (this.currentOffset > this.maxOffset) {
                    this.currentOffset = 0;
                }
                else {
                    this.currentOffset = this.currentOffset + this.thumbnailWidth;
                }
            }
            console.log('in scrollForward currentOffset '+this.currentOffset + ' maxOffset ' + this.maxOffset);
            this.scrollToPosition(this.currentOffset);
        };

        /**
         *
         * @method scrollBackward
         * @param event {Event} JavaScript event object.
         * @private
         */
        ThumbnailSliderView.prototype.scrollBackward = function (event) {
            //needed for IE Support
            if (event.preventDefault) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }
            
            this.$triggerNext.removeClass('triggerInactive');
            console.log('in scrollBackword currentOffset '+this.currentOffset);
            if (!this.isLooping) {
                this.currentOffset = this.currentOffset - this.thumbnailWidth;
                if (this.currentOffset < 0) {
                    this.currentOffset = 0;
                    this.$triggerPrevious.addClass('triggerInactive');
                }
            }
            else {
                if (this.currentOffset < 0) {
                    this.currentOffset = this.maxOffset;
                }
                else {
                    this.currentOffset = this.currentOffset - this.thumbnailWidth;
                }
            }
            this.scrollToPosition(this.currentOffset);
        };

        /**
         *
         * @method scrollToPosition
         * @param position
         * @private
         */
        ThumbnailSliderView.prototype.scrollToPosition = function (position) {
            var self = this;
            var animationProp = {};
            var animatePosition = position;
            var animationSpeed = 500;

            if (this.shouldUseRTL) {
                animationProp = {marginRight: -animatePosition};
            } else {
                animationProp = {marginLeft: -animatePosition};
            }

            this.isAnimating = true;

            this.$sliderList.stop().animate(animationProp, animationSpeed, function () {
                self.isAnimating = false;
            });
        };

        return ThumbnailSliderView;
    });

}(MMMRequire));

